// File: frontend/src/components/FitenkoUzor.js
// Version: 1.0 (quick-260910-jkl)
// Date: 2026-09-10
// Назначение: ЕДИНСТВЕННЫЙ ДЕРЖАТЕЛЬ узора замысла в разметке — шапка страницы
//             и оболочка блока. Оформление этих же узлов живёт единственным
//             разделом 7.6 в styles/fitenko-shell.css. Двух мест нет ни у формы,
//             ни у вида: разойтись им было бы нечем, и разошлись бы они МОЛЧА.
//
// 🔴 ЗАЧЕМ ВЫНЕСЕНО СЕЙЧАС, А НЕ ПОСЛЕ ПЯТОГО ЭКРАНА. Замер quick-260910-iji
//    показал: узор привязан именами к одному экрану, и на каждом следующем он
//    станет копией. При 28 экранах правка замысла потребовала бы 28 мест.
//    Стоимость выноса растёт с числом уже написанных копий — здесь копий было 0
//    в разметке и 2 у обёртки экрана.
//
// 🔴 ФОРМА ШАПКИ ПОДХОДИТ НЕ ОБОИМ ЭКРАНАМ. Экран «История» под неё НЕ ПОДОГНАН,
//    и различия НАЗВАНЫ, а не спрятаны в необязательные части. Их три:
//      (1) надзаголовка капителью у него НЕТ;
//      (2) главного действия справа у него НЕТ;
//      (3) раскладка у него СТОЛБЕЦ без внутренней текстовой обёртки, отступ
//          снизу на один шаг меньше, а H1 несёт СВОЁ назначение гарнитуры,
//          тогда как здесь оно приходит каскадом.
//    Перевод его шапки на общую сдвинул бы отступ на 4 px — это ВИДИМОЕ
//    изменение. Сдвиг на 4 px — решение владельца, а не побочный эффект уборки.
//
// 🔴 НЕОБЯЗАТЕЛЬНЫХ ЧАСТЕЙ У ШАПКИ НЕТ НАРОЧНО. Соблазн «сделать надзаголовок и
//    действие необязательными, чтобы влез и второй экран» отклонён: ветку, которую
//    никто не исполняет, ничто и не проверяет — это ГИПОТЕЗА, стоящая в коде под
//    видом работающего кода. [[knowledge_unexercised_branch_is_a_hypothesis]]
//    Все пять пропсов шапки ОБЯЗАТЕЛЬНЫ. Вторую форму заведёт тот, у кого она
//    появится, — вместе с НАСТОЯЩИМ потребителем.
//
// 🔴 ВТОРАЯ ФОРМА ШАПКИ ЗАВЕДЕНА 11.09.2026 (quick-260911-27v) — И У НЕЁ ЕСТЬ
//    НАСТОЯЩИЙ ПОТРЕБИТЕЛЬ. Это `pages/FitenkoObrashcheniya.js`: экран
//    обращений, у которого ГЛАВНОГО ДЕЙСТВИЯ СПРАВА НЕТ (решение владельца
//    Д-08). Причина не вкусовая и проверяема: ручка `POST /leads/` существует
//    (`backend/app/api/endpoints/leads.py:114`), а МАРШРУТА И ЭКРАНА создания
//    обращения нет — `apiService.createLead` не зовёт НИКТО (греп по
//    `frontend/src`: 0 вызовов). Кнопка «Новое обращение» вела бы в никуда.
//
//    🔴 ПОЧЕМУ ОТДЕЛЬНЫЙ ВЫВОД, А НЕ НЕОБЯЗАТЕЛЬНЫЙ ПРОП У `ShapkaEkrana`.
//    Необязательный проп спрятал бы РАЗВИЛКУ внутрь разметки: снаружи обе формы
//    выглядели бы одной, и «есть ли у экрана главное действие» стало бы
//    свойством переданного значения, а не решением, видимым в коде. Отдельный
//    вывод делает исполнение обеих ветвей видимым в списке экспортов, а не в
//    условии внутри JSX. Обе ветви исполняются НАСТОЯЩИМИ экранами —
//    `FitenkoToday` берёт первую, `FitenkoObrashcheniya` вторую, — значит
//    гипотезой под видом кода не является ни одна.
//    🔴 ДВЕ ФОРМЫ НЕ ДУБЛИРУЮТ ДРУГ ДРУГА: у первой в правом углу ДЕЙСТВИЕ
//    (переход туда, где работа продолжается), у второй — НИЧЕГО, а возврат
//    стоит НАД заголовком и оформлен ссылкой, а не кнопкой. Спутать их значило
//    бы предложить человеку возврат в виде главного действия экрана.
//
// 🔴 ОБЩЕЙ СТАЛА ОБЁРТКА ЭКРАНА (.fk-page), потому что потребителей у неё
//    ДЕЙСТВИТЕЛЬНО двое и объявления совпадали дословно. Это единственное место,
//    где число держателей упало 2 → 1 прямо сейчас и доказуемо.
//
// 🔴 СТРОЧНЫЕ ПРИМИТИВЫ ЭКРАНА «Сегодня» (список, строка, время, заголовок,
//    таблетка, кнопка) СЮДА НЕ ВЫНЕСЕНЫ: потребитель у них ОДИН. Вынести форму
//    по одному потребителю — угадать её. Названо как кандидат на следующий
//    экран, а не забыто.
//
// 🔴 ТЕГИ h1 И h2 СОХРАНЕНЫ. Гарнитура приходит каскадом от html.fitenko h1..h4;
//    подмена тега на div изменила бы вид, НИЧЕГО не сказав.
//
// 🔴 ТРЕТЬЯ ФОРМА ШАПКИ ЗАВЕДЕНА 12.09.2026 (quick-260912-23z) — И У НЕЁ ТОЖЕ
//    ЕСТЬ НАСТОЯЩИЙ ПОТРЕБИТЕЛЬ. Это `pages/AIParalegal.js`: у экрана главное
//    действие ЕСТЬ, но оно не переход, а КНОПКА НА МЕСТЕ (открывает окно
//    создания дела). Маршрута у создания дела нет вовсе — `to` пришлось бы
//    выдумать, и ссылка повела бы в никуда. Довод и различия — у самого вывода.
//
// 🔴 ВСЕ ЧЕТЫРЕ ВЫВОДА — ЧИСТЫЕ: пропсы → разметка. Ни одного обращения к данным,
//    ни одного собственного состояния. Рубеж арендатора здесь тоже НЕ ЗАВОДИТСЯ:
//    он стоит выше по маршруту, и второй рубеж означал бы двух держателей
//    одного решения.

import React from 'react';
import { Link } from 'react-router-dom';

// Шапка страницы: надзаголовок капителью, H1, строка-пояснение и главное
// действие справа. Действие — ПЕРЕХОД, а не утверждение о состоянии.
export const ShapkaEkrana = ({ nadzagolovok, zagolovok, podstroka, kuda, podpis }) => (
    <header className="fk-page-head">
        <div className="fk-page-headtext">
            <span className="fk-page-kicker">{nadzagolovok}</span>
            <h1 className="fk-page-h1">{zagolovok}</h1>
            <p className="fk-page-sub">{podstroka}</p>
        </div>
        <Link className="fk-page-act" to={kuda}>{podpis}</Link>
    </header>
);

// Шапка БЕЗ главного действия: над заголовком — скромный возврат, справа пусто.
// Адрес возврата приходит пропсом: держатель адресов один и он в
// `config/fitenkoNav.js` (LEGACY_DESTINATIONS), а не строкой в разметке.
export const ShapkaBezDeystviya = ({ nadzagolovok, zagolovok, podstroka, nazadKuda, nazadPodpis }) => (
    <header className="fk-page-head">
        <div className="fk-page-headtext">
            <Link className="fk-page-nazad" to={nazadKuda}>{nazadPodpis}</Link>
            <span className="fk-page-kicker">{nadzagolovok}</span>
            <h1 className="fk-page-h1">{zagolovok}</h1>
            <p className="fk-page-sub">{podstroka}</p>
        </div>
    </header>
);

// ТРЕТЬЯ ФОРМА ШАПКИ: главное действие ЕСТЬ, но оно КНОПКА НА МЕСТЕ, а не
// переход. Заведена 12.09.2026 (quick-260912-23z) — и у неё есть НАСТОЯЩИЙ
// потребитель: `pages/AIParalegal.js`, где главное действие экрана открывает
// окно создания дела (`setIsModalOpen`, дальше `handleCreateCase`), никуда не
// уводя человека с экрана. Ссылкой это выразить нечем: маршрута у создания дела
// нет, и `to` пришлось бы выдумать.
//
// 🔴 ПОЧЕМУ ОТДЕЛЬНЫЙ ВЫВОД, А НЕ НЕОБЯЗАТЕЛЬНЫЙ ПРОП У `ShapkaEkrana`. Тот же
//    довод, что и у второй формы: необязательный проп спрятал бы РАЗВИЛКУ
//    внутрь разметки, и «уводит ли главное действие с экрана» стало бы
//    свойством переданного значения, а не решением, видимым в списке экспортов.
//    Все пять пропсов ОБЯЗАТЕЛЬНЫ; ветка исполняется настоящим экраном.
// 🔴 ОФОРМЛЕНИЕ НЕ ЗАВОДИТСЯ ВТОРОЙ РАЗ: кнопка берёт тот же класс
//    `.fk-page-act`, что и ссылка первой формы, а различие кнопки от ссылки
//    (гарнитура и курсор) дописано ОДНИМ правилом в том же разделе 7.6.
export const ShapkaSKnopkoy = ({ nadzagolovok, zagolovok, podstroka, podpis, naZhatie }) => (
    <header className="fk-page-head">
        <div className="fk-page-headtext">
            <span className="fk-page-kicker">{nadzagolovok}</span>
            <h1 className="fk-page-h1">{zagolovok}</h1>
            <p className="fk-page-sub">{podstroka}</p>
        </div>
        <button type="button" className="fk-page-act" onClick={naZhatie}>{podpis}</button>
    </header>
);

// Оболочка блока: заголовок, ссылка «дальше», содержимое, мелкая оговорка.
// Оговорка — единственная необязательная часть, и она была необязательной ДО
// выноса: это переезд условия, а не новая ветка.
export const ObolochkaBloka = ({ klass, zagolovok, kuda, podpis, ogovorka, children }) => (
    <section className={`fk-page-card ${klass}`}>
        <div className="fk-page-cardhead">
            <h2 className="fk-page-cardtitle">{zagolovok}</h2>
            <Link className="fk-page-more" to={kuda}>{podpis}</Link>
        </div>
        {children}
        {ogovorka ? <p className="fk-page-note">{ogovorka}</p> : null}
    </section>
);

// Состояние ВМЕСТО содержимого: «грузим», «отказано», «не смогли спросить»,
// «пусто». Четыре разных ответа, и одинаковыми словами они не говорят.
export const Sostoyanie = ({ tekst }) => <p className="fk-page-state">{tekst}</p>;
